import {
  Box,
  Typography,
  // Grid,
  Autocomplete,
  TextField,
  Button,
  Divider,
  Dialog,
  Stack,
  Tooltip,
  Menu,
  MenuItem,
  // selectClasses,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import Styles from "./CommonMail.module.scss";
import EmptyDataImage from "../../assets/images/emptyDataImage.png";
import ReassignIcon from "../../assets/images/Container.png";

import AssignedByIcon from "../../assets/staffConnect/AssignedBy.png";
import AssignedToIcon from "../../assets/staffConnect/AssignedTo.png";
import ProjectIcon from "../../assets/staffConnect/Project.png";
import AssignedHoursIcon from "../../assets/staffConnect/Hours.png";

import moment from "moment";
import { Checkbox } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
// import {
//   readMail,
//   sendMail,
//   updateMailMessage,
//   deleteMailMessage,
//   fetchReplyMails,
// } from "../../services/mail.service";
// import { toastError, toastSuccess } from "../../utils/toaster";
// import MoreOptBtn from "./MoreOptBtn";
import { ColorRing } from "react-loader-spinner";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers";
// import { errorMessage } from "../../utils/errorHandleFunctions";
import ModeIcon from "@mui/icons-material/Mode";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Form, Field } from "formik";
// import LoadingButton from "../../sharedComponents/LoadingButton/loadingButton";
import dayjs from "dayjs";
import ConfirmBox from "../ConfirmBox/ConfirmBox";
// import { Roles } from "../../constants/menus";
// import { Timer } from "../../constants/timer";
import ReplyIcon from "@mui/icons-material/Reply";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { AutoComplete } from "../_index";
import {
  addConversation,
  alertCloseMessage,
  closeTicket,
  getChatConversation,
  updateTicket,
} from "../../services/ticket.service";

import { message } from "antd";
import { SEND_STATUS_OPTIONS } from "../../constant/constant";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import PDFImage from "../../assets/images/pdf2.png";
import XLSXImage from "../../assets/images/xlsx2.png";
import ReactDOMServer from "react-dom/server";
// import { useLocation } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import VoiceRecorder, { buildVoiceFile } from "./VoiceRecorder";

const commonEmail = "corphelpdesk@wshexperts.com.sg";

// Only the roles that manage tickets may push the complete-by date out — the
// backend enforces the same list server-side, this just keeps the control
// off the screen for everyone else (e.g. the staff the ticket was raised for).
const EXTEND_EXPIRY_ROLES = ["FEEDBACK-ADMIN", "HR", "PROJECT MANAGER"];
// Extending the complete-by date applies to IT Support tickets only. The
// assigned department's role name wins; `department` covers older rows.
const isItSupportTicket = (ticket) =>
  String(ticket?.roleName || ticket?.dept?.name || ticket?.department || "")
    .trim()
    .toUpperCase() === "IT SUPPORT";

const AUDIO_EXTENSIONS = ["m4a", "mp4a", "aac", "mp3", "webm", "ogg", "wav"];
const isAudioDocument = (doc) =>
  doc?.fileType?.startsWith("audio/") ||
  AUDIO_EXTENSIONS.includes(
    (doc?.fileName || doc?.fileUrl || "").toLowerCase().split(".").pop()
  );

const ContentFeedback = ({
  selectedData,
  setOpenConfirmBox,
  setOpenExpiryBox,
  status,
  setStatus,
  getInitialStatus,
  getTicketUserData,
}) => {
  const dispatch = useDispatch();

  // Log selectedData only when it changes, not on every render
  useEffect(() => {
    if (selectedData && Object.keys(selectedData).length > 0) {
      try {
        // Safely log selectedData by creating a clean copy
        const cleanData = { ...selectedData };
      } catch (error) {
        console.log("Error logging selectedData:", error);
      }
    }
  }, [selectedData]);

  const [replyData, setReplyData] = useState(selectedData?.replyMessages || []);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [sendOpenLoader, setSendOpenLoader] = React.useState(false);
  const [sendCloseLoader, setSendCloseLoader] = React.useState(false);
  const [openMailBox, setOpenMailBox] = React.useState(false);
  const [selectedId, setSelectedId] = useState();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState({});
  const [openDialogBox, setOpendialogBox] = useState(false);
  const [definedRole, setDifinedRole] = useState(null);
  const [isInitMessageSent, setIsInitMessageSent] = useState(false);
  const [viewConfig, setViewConfig] = useState({
    isEdit: false,
    isDelete: false,
  });
  const statusOptions = [
    { value: "0", label: "Open" },
    { value: "1", label: "Closed" },
  ];

  // const location = useLocation();
  // const [currentPath, setCurrentPath] = useState(window?.location?.search);
  // console.log(currentPath, "CCPP");

  // useEffect(() => {
  //   if (window?.location?.search) {
  //     // This will be triggered when the URL loads for the first time
  //     setCurrentPath(window?.location?.search);

  //     // Close ticket logic
  //     closeTicket(window?.location?.search);

  //     // Remove the query parameters from the URL (keep the base path)
  //     const newUrl = window.location.pathname;
  //     window.history.replaceState(null, "", newUrl); // Removes query string
  //   }
  // }, []);

  const [currentStatus, setCurrentStatus] = useState({});

  useEffect(() => {
    if (selectedData?.replyMessages) {
      setReplyData(selectedData.replyMessages);
    }
  }, [selectedData]);

  const [mailValues, setMailValues] = useState({
    body: "",
    cc: "",
    isReply: "",
    date: "",
  });
  React.useEffect(() => {
    setStatus(getInitialStatus);
  }, [selectedData]);
  React.useEffect(() => {
    if (selectedData?.ticketStatus) {
      const initialStatus = statusOptions.find(
        (status) => status.value === selectedData.ticketStatus
      );
      if (currentStatus.value !== initialStatus?.value) {
        setCurrentStatus(
          initialStatus || selectedData?.ticketStatus === "0"
            ? "Open"
            : selectedData?.ticketStatus === "1"
            ? "Hole"
            : "Closed"
        );
      }
    }
  }, [selectedData]);

  const endOfMessagesRef = useRef(null);

  const [replyMessages, setReplyMessage] = useState([]);

  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [replyMessages]);

  const getConversation = async () => {
    setOpenLoader(true);
    try {
      const ticketId = selectedData?.ticketId;
      const res = await getChatConversation(ticketId);
      const configData = (res?.data || []).map((e) => {
        return {
          ...e,
        };
      });
      setReplyMessage(configData);
      setOpenLoader(false);
    } catch (error) {
      console.log(error);
    }
  };
  const currentUserId = localStorage.getItem("userId");

  const [fileName, setFileName] = useState("");
  const [documents, setDocuments] = useState([]);
  const [voiceNote, setVoiceNote] = useState(null);

  const clearVoiceNote = () => {
    if (voiceNote?.url) URL.revokeObjectURL(voiceNote.url);
    setVoiceNote(null);
  };

  useEffect(() => {
    clearVoiceNote();
  }, [selectedData?.ticketId]);

  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    // const file = event.target.files[0];
    // if (file) {
    //   console.log("File selected:", file);
    //   setFileName(file.name);
    //   setDocuments(file);
    // }
    const files = event.target.files;
    if (files.length > 0) {
      setFileName(
        Array.from(files)
          .map((file) => file.name)
          .join(", ")
      );
      setDocuments(files);
    }
  };

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleSendClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOptionClick = async (selectedValue) => {
    if (selectedValue === "2") {
      setIsInitMessageSent(true);
    }
    setAnchorEl(null);
    setSendOpenLoader(true);
    try {
      await sendMailFunction(selectedValue).then(() => {
        getTicketUserData();
      });
      const values2 = {
        ticketId: selectedData.ticketId,
      };
      if (
        selectedValue ==
        SEND_STATUS_OPTIONS?.find((s) => s?.label == "Final")?.value
      ) {
        await alertCloseMessage(values2).then((res) => getConversation());
      }
    } finally {
      setSendOpenLoader(false);
    }
  };

  const sendOptions = [
    { label: "Initial", value: "2" },
    { label: "Need info", value: "5" },
    { label: "Final", value: "4" },
  ];

  const hasSentAnyMessage = replyMessages.some(
    (msg) => msg.userId === currentUserId
  );

  const filteredSendOptions = hasSentAnyMessage
    ? sendOptions.filter((opt) => opt.value !== "2")
    : sendOptions;

  const sendMailFunction = async (type) => {
    setSendOpenLoader(true);
    const message = mailValues?.body?.trim();
    if (!message && !voiceNote) {
      setIsInitMessageSent(false);
      dispatch(
        showToast({
          message: "Please fill the message content",
          type: "error",
        })
      );
      setSendOpenLoader(false);
      return;
    }
    try {
      const ticketId = selectedData.ticketId;
      const currentUserId = localStorage.getItem("userId");
      const formData = new FormData();

      const values = {
        userId: currentUserId,
        message: mailValues?.body || "",
        sendStatus: type,
        isFromWeb: true,
        ...(voiceNote ? { voiceDuration: voiceNote.duration } : {}),
      };
      formData.append("values", JSON.stringify(values));
      // if (documents) {
      //   if (documents) {
      //     formData.append("files", documents);
      //   }
      // }

      if (documents) {
        Array.from(documents).forEach((file) => {
          formData.append("files", file);
        });
      }
      if (voiceNote) {
        formData.append("files", buildVoiceFile(voiceNote));
      }
      // Send the FormData with the ticketId
      const res = await addConversation(ticketId, formData);

      setMailValues({});
      setSendOpenLoader(false);
      setOpenMailBox(false);
      getConversation();
      setDocuments(null);
      setFileName("");
      clearVoiceNote();
    } catch (error) {
      dispatch(
        showToast({
          message: error?.data?.message || "Failed to send message. Please try again.",
          type: "error",
        })
      );
      setSendOpenLoader(false);
      setOpenMailBox(false);
    }
  };

  const sendCloseMailFunction = async () => {
    try {
      const ticketId = selectedData.ticketId;
      const currentUserId = localStorage.getItem("userId");
      const formData = new FormData();

      // Create the message with buttons
      const messageWithButtons = (
        <div>
          <p>Please confirm if you want to close the ticket.</p>
          <button>
            <a
              href={`https://feedback-tstapi.mywsh.com.sg/api/feedback/updateTicketStatus?ticketId=${ticketId}&ticketStatus=1`}
              // href={`http://localhost:3000/api/feedback/updateTicketStatus?ticketId=${ticketId}&ticketStatus=1`}
            >
              Yes
            </a>
          </button>
          <button>
            <a
            // href={`http://localhost:3000/api/feedback?ticketId=${ticketId}&ticketStatus=0`}
            >
              No
            </a>
          </button>
        </div>
      );

      const messageString =
        ReactDOMServer.renderToStaticMarkup(messageWithButtons);

      const values = {
        userId: currentUserId,
        message: messageString,
        isCloseMessage: true,
        isFromWeb: true,
      };

      formData.append("values", JSON.stringify(values));

      // Send the FormData with the ticketId to the backend
      await addConversation(ticketId, formData);

      setOpenMailBox(false);
      getConversation();
    } catch (error) {
      dispatch(
        showToast({
          message: error?.data?.message || "Failed to send message. Please try again.",
          type: "error",
        })
      );
      setSendOpenLoader(false);
      setOpenMailBox(false);
    }
  };

  // Handle Button Click for Yes/No
  const handleButtonClick = (response, ticketId) => {
    try {
      // Call updateTicketStatus and send response to backend
      updateTicketStatus(response, ticketId);
    } catch (error) {
      console.error("Error handling button click:", error);
    }
  };

  const updateTicketStatus = async (response, ticketId) => {
    setSendCloseLoader(true);
    const message = mailValues?.body?.trim();
    if (!message) {
      setIsInitMessageSent(false);
      dispatch(
        showToast({
          message: "Please fill the message content",
          type: "error",
        })
      );
      setSendCloseLoader(false);
      return; // stop here
    }
    try {
      const ticketId = selectedData.ticketId;
      const formData = new FormData();
      const values1 = {
        userId: currentUserId,
        message: mailValues?.body,
        isFromWeb: true,
      };
      formData.append("values", JSON.stringify(values1));
      const res1 = await addConversation(ticketId, formData);
      // If res1 fails or doesn't return success, skip the rest
      if (!res1) {
        throw new Error(res1?.message || "Failed to send conversation");
      }

      const values2 = {
        ticketId: selectedData.ticketId,
      };
      const res2 = await alertCloseMessage(values2);

      setMailValues({});
      setSendCloseLoader(false);
      setOpenMailBox(false);
      getConversation();
      setDocuments(null);
      setFileName("");
      dispatch(showToast({ message: res2?.message, type: "success" }));
    } catch (error) {
      console.error("Error updating ticket status:", error);
      dispatch(showToast({ message: error?.data?.message, type: "error" }));
      setSendCloseLoader(false);
    }
  };

  React.useEffect(() => {
    if (selectedData.status) {
      const subject = selectedData.referenceNumber;
      readEmailFunction(subject);
    }
  }, [selectedData.referenceNumber]);

  useEffect(() => {
    if (selectedData?.ticketId) {
      getConversation(selectedData.ticketId);
    }
  }, [selectedData?.ticketId]);

  const readEmailFunction = async (subject) => {
    setOpenLoader(true);
    try {
      const res = await subject;
      setOpenLoader(false);
      setReplyData(res.data);
    } catch (error) {
      setOpenLoader(false);
      console.log(error);
    }
  };

  const handleEditMessage = (values) => {
    // setLoading(true);
    // updateMailMessage(selectedMessage._id, values).then((res) => {
    //   toastSuccess(res.message);
    //   setLoading(false);
    //   setOpenDrawer(false);
    //   const subject = selectedData.referenceNumber;
    //   readEmailFunction(subject);
    // });
  };

  const handleReassigned = () => {
    setLoading(true);
    updateTicket(selectedData._id, { isReAssigned: true }).then((res) => {
      dispatch(showToast({ message: res.message, type: "success" }));
      setLoading(false);
      getTicketUserData();
    });
  };
  const [supportTicket, setSupportTicket] = useState(false);

  const [openSupportConfirmBox, setOpenSupportConfirmBox] = useState(false);
  const [pendingValue, setPendingValue] = useState(null); // store clicked value

  useEffect(() => {
    if (selectedData?.SupportTicket !== undefined) {
      setSupportTicket(selectedData.SupportTicket);
    } else {
      setSupportTicket(false);
    }
  }, [selectedData]);

  // ✅ Open confirm box when user clicks
  const handleCheckboxClick = (e) => {
    const checked = e.target.checked;
    setPendingValue(checked); // store intended value (true/false)
    setOpenSupportConfirmBox(true);
    e.preventDefault(); // stop immediate toggle
  };

  const handleSupportTicket = async () => {
    if (pendingValue === null) return;

    setLoading(true);
    try {
      const res = await updateTicket(selectedData._id, {
        SupportTicket: pendingValue,
      });
      dispatch(showToast({ message: res.message, type: "success" }));
      setSupportTicket(pendingValue);
      setOpenSupportConfirmBox(false);
      getTicketUserData();
    } catch (error) {
      dispatch(
        showToast({ message: "Failed to update Support Ticket", type: "error" })
      );
    } finally {
      setLoading(false);
      setPendingValue(null);
    }
  };

  const currentUserName = localStorage.getItem("userName");
  const currentUserEmail = localStorage.getItem("email");

  const replyList = replyMessages || [];
  let filteredMessages = [...replyList];

  const lastMessage = replyList[replyList.length - 1];

  if (lastMessage && lastMessage.isAutoGenerated === false) {
    // Filter out only earlier auto-generated messages
    filteredMessages = replyList.filter((msg, index) => {
      // If it's not auto-generated, always keep
      if (!msg.isAutoGenerated) return true;

      // If it's auto-generated, only keep it if it's after the last user message
      // So find the index of the last non-auto message
      const lastUserIndex = [...replyList]
        .reverse()
        .findIndex((m) => m.isAutoGenerated === false);

      const realIndex = replyList.length - 1 - lastUserIndex;

      // Keep this message only if it's after the last user message
      return index >= realIndex;
    });
  }

  return (
    <div className={Styles.contentFeedbackContainer}>
      {Object.keys(selectedData).length ? (
        <Box>
          <Box
            className={Styles.closeMailheaderCenterCompainer}
            // className={
            //   openMailBox
            //     ? Styles.headerCenterCompainer
            //     : Styles.closeMailheaderCenterCompainer
            // }
          >
            <Box
              className={Styles.bigContainerTop}
              // sx={{ position: "absolute" }}
            >
              <Box sx={{ position: "relative", width: "100%" }}>
                <Box sx={{ display: "flex" }}>
                  <Box mr={2}>
                    <Typography
                      className={Styles.logo}
                      sx={{
                        backgroundColor: "#F54D60",
                        textTransform: "uppercase",
                      }}
                    >
                      {/* {selectedData?.name[0]} */}
                      {/* {selectedData?.name[1]} */}
                      {selectedData?.createdByInfo ? (
                        <>
                          {selectedData?.createdByInfo?.name[0]}
                          {selectedData?.createdByInfo?.name[1]}
                        </>
                      ) : selectedData?.name ? (
                        <>
                          {selectedData?.name?.[0]}
                          {selectedData?.name?.[1]}
                        </>
                      ) : (
                        (
                          selectedData?.createdByInfo?.email ||
                          selectedData?.createdByEmail ||
                          selectedData?.email
                        )
                          ?.split("@")[0]
                          ?.slice(0, 2)
                          ?.toUpperCase() || "NA"
                      )}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                    >
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box>
                            <Typography
                              className={Styles.headlineText}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {
                                selectedData?.createdByInfo?.name ||
                                selectedData?.name ||
                                (
                                  selectedData?.createdByInfo?.email ||
                                  selectedData?.createdByEmail ||
                                  selectedData?.email
                                )?.split("@")[0] ||
                                "Unknown User"}
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: 8,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  fontFamily: '"Inter", sans-serif',
                                  color:
                                    selectedData?.status === "closed"
                                      ? "#CC0000"
                                      : "#009688",
                                  backgroundColor:
                                    selectedData?.status === "closed"
                                      ? "#CC0000"
                                      : "#DCFCE7",
                                  padding: "2px 6px",
                                  borderRadius: "20px",
                                  textTransform: "capitalize",
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: 8,
                                    height: 8,
                                    borderRadius: "50%",
                                    marginRight: 5,
                                    backgroundColor:
                                      selectedData?.status === "closed"
                                        ? "#CC0000"
                                        : "#009688",
                                  }}
                                ></span>
                                {selectedData?.status === "closed"
                                  ? "Closed"
                                  : "Open"}
                              </span>
                            </Typography>
                            <Typography className={Styles.content}>
                              &nbsp;&nbsp;(
                              {(
                                selectedData?.createdByInfo?.email ||
                                selectedData?.email
                              )?.length > 30
                                ? `${(
                                    selectedData?.createdByInfo?.email ||
                                    selectedData?.email ||
                                    "Unknown Mail"
                                  )?.slice(0, 30)}...`
                                : selectedData?.createdByInfo?.email ||
                                  selectedData?.email ||
                                  "Unknown Mail"}
                              )
                            </Typography>
                          </Box>
                          {/* <Typography className={Styles.date}>
                            {moment(selectedData?.createdAt).format(
                              "DD MMM YYYY, hh:mma"
                            )}
                          </Typography> */}
                        </Box>
                      </Grid>
                      <Grid
                        size={{ xs: 12, sm: 6 }}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={supportTicket}
                                onClick={handleCheckboxClick}
                                color="primary"
                                disabled={loading}
                              />
                            }
                            label={
                              <span
                                style={{ fontFamily: '"Inter", sans-serif' }}
                              >
                                Follow up
                              </span>
                            }
                          />
                          <Button
                            onClick={handleReassigned}
                            className="reAssignButton"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src={ReassignIcon}
                              alt="Reassign"
                              style={{ width: "20px", height: "15px" }}
                            />
                            Re Assign
                          </Button>
                        </Box>
                      </Grid>
                      {/* <Grid
                        size={{ xs: 12, sm: 3.5 }}
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box sx={{ display: "flex" }}>
                            <Typography className={Styles.headline}>
                              Assigned To : 
                            </Typography>
                            <Typography className={Styles.content}>
                              &nbsp;&nbsp;{selectedData?.assignedToInfo?.name}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", whiteSpace: "nowrap" }}>
                            <Typography className={Styles.headline}>
                              Assigned At :
                            </Typography>
                            <Typography className={Styles.content}>
                              &nbsp;&nbsp;
                              {moment(selectedData?.assignedAt).format(
                                "DD MMM YYYY, hh:mma"
                              )}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", whiteSpace: "nowrap" }}>
                            <Typography className={Styles.headline}>
                              Assigned By :
                            </Typography>
                            <Typography className={Styles.content}>
                              &nbsp;&nbsp;{selectedData?.assignedByInfo?.name}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid> */}
                      {/* <Grid size={{ xs: 12, sm: 2.5 }}>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Box sx={{ display: "flex", whiteSpace: "nowrap" }}>
                            <Typography className={Styles.headline}>
                              Hours Of Assigned :
                            </Typography>
                            <Typography className={Styles.content}>
                              &nbsp;&nbsp;{selectedData?.workingDuration}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", whiteSpace: "nowrap" }}>
                           
                          </Box>
                        </Box>
                        {!selectedData.isReAssigned && (
                          <Button
                            onClick={handleReassigned}
                            className="reAssignButton"
                          >
                            Re Assign
                          </Button>
                        )}
                        <Box>
                          <Typography className={Styles.headline}>
                            Project Name :
                          </Typography>
                          <Typography className={Styles.content}>
                            &nbsp;&nbsp;
                            {selectedData?.createdByInfo.projectName}
                          </Typography>
                        </Box>
                      </Grid> */}
                      {/* <Grid size={{ xs: 12, sm: 2 }}>
                        <Grid
                          container
                          sx={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Grid size={{ xs: 12, sm: 8 }}>
                            <Autocomplete
                              name="ticketStatus"
                              placeholder="Select Status"
                              options={statusOptions}
                              value={status}
                              onChange={(e, v) => {
                                setStatus(v);
                              }}
                              disabled={true}
                              clearIcon={null}
                              popupIcon={null}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  inputProps={{
                                    ...params.inputProps,
                                    readOnly: true,
                                    endAdornment: null,
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={supportTicket}
                                onClick={handleCheckboxClick}
                                color="primary"
                                disabled={loading}
                              />
                            }
                            label="Follow up"
                          />
                        </Grid>
                      </Grid> */}
                    </Grid>
                    <Grid container spacing={2} mt={2}>
                      {/* Box 1: Assigned To */}
                      <Grid size={{ xs: 12, md: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f1f1f1",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            minHeight: "54px",
                            boxShadow: "0 1px 4px #0001",
                            width: "100%",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#CCFBF1",
                              borderRadius: "3px",
                              padding: "5px",
                            }}
                          >
                            <img
                              src={AssignedToIcon}
                              alt="Assigned To"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontFamily: "Inter,Sans-Serif",
                                fontSize: 12,
                                color: "#666",
                              }}
                            >
                              Assigned To
                            </Typography>
                            <Tooltip
                              title={ selectedData?.assignedToInfo?.name || "-"}
                              arrow
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter,Sans-Serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  color: "#111",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                }}
                              >
                                {selectedData?.assignedToInfo?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Grid>
                      {/* Box 2: Assigned By */}
                      <Grid size={{ xs: 12, sm: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f1f1f1",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            minHeight: "54px",
                            boxShadow: "0 1px 4px #0001",
                            width: "100%",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#DBEAFE",
                              borderRadius: "3px",
                              padding: "5px",
                            }}
                          >
                            <img
                              src={AssignedByIcon}
                              alt="Assigned By"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter,Sans-Serif",
                                fontWeight: 600,
                                fontSize: 12,
                                color: "#666",
                              }}
                            >
                              Assigned By
                            </Typography>
                            <Tooltip
                              title={selectedData?.assignedByInfo?.name || "-"}
                              arrow
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter,Sans-Serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  color: "#111",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                }}
                              >
                                {selectedData?.assignedByInfo?.name || "-"}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Grid>
                      {/* Box 3: Project */}
                      <Grid size={{ xs: 12, sm: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f1f1f1",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            minHeight: "54px",
                            boxShadow: "0 1px 4px #0001",
                            width: "100%",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#F3E8FF",
                              borderRadius: "3px",
                              padding: "5px",
                            }}
                          >
                            <img
                              src={ProjectIcon}
                              alt="Project"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter,Sans-Serif",
                                fontWeight: 600,
                                fontSize: 12,
                                color: "#666",
                              }}
                            >
                              Project
                            </Typography>
                            <Tooltip
                              title={
                                selectedData?.createdByInfo?.projectName || "-"
                              }
                              arrow
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter,Sans-Serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  color: "#111",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                }}
                              >
                                {selectedData?.createdByInfo?.projectName ||
                                  "-"}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Grid>
                      {/* Box 4: Assigned Hours & At (combined with a grid within) */}
                      <Grid size={{ xs: 12, sm: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f1f1f1",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            minHeight: "54px",
                            boxShadow: "0 1px 4px #0001",
                            width: "100%",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#FEF3C7",
                              borderRadius: "3px",
                              padding: "5px",
                            }}
                          >
                            <img
                              src={AssignedHoursIcon}
                              alt="Assigned Hours"
                              style={{ width: "20px", height: "20px" }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontFamily: "Inter,Sans-Serif",
                                fontWeight: 600,
                                fontSize: 12,
                                color: "#666",
                              }}
                            >
                              Hours / Assigned At
                            </Typography>
                            <Tooltip
                              title={`${
                                selectedData?.workingDuration || "-"
                              } / ${moment(selectedData?.assignedAt).format(
                                "DD MMM YYYY, hh:mma"
                              )}`}
                              arrow
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter,Sans-Serif",
                                  fontWeight: 500,
                                  fontSize: 14,
                                  color: "#111",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                }}
                              >
                                {selectedData?.workingDuration || "-"} /{" "}
                                {moment(selectedData?.assignedAt).format(
                                  "DD MMM YYYY, hh:mma"
                                )}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid className={Styles.countHeader} mt={2}>
                      <Grid sx={{ display: "flex" }}>
                        <Typography className={Styles.content}>
                          Ref.Number :{" "}
                        </Typography>
                        <Typography className={Styles.value}>
                          {selectedData?.ticketId}
                        </Typography>
                      </Grid>
                      {EXTEND_EXPIRY_ROLES.includes(
                        localStorage.getItem("role")
                      ) && (
                        <Grid
                          sx={{
                            display: "flex",
                            cursor: isItSupportTicket(selectedData)
                              ? "pointer"
                              : "default",
                          }}
                          onClick={() =>
                            isItSupportTicket(selectedData) &&
                            setOpenExpiryBox(true)
                          }
                        >
                          <Typography className={Styles.content}>
                            Complete Within :{" "}
                          </Typography>
                          <Typography className={Styles.value}>
                            &nbsp;{Number(selectedData?.expiry) || 2} days
                          </Typography>
                          {isItSupportTicket(selectedData) && (
                            <Typography
                              className={Styles.value}
                              style={{ marginLeft: 12, color: "#00675D", textDecoration: "underline" }}
                            >
                              {selectedData?.ticketStatus === "1" ? "History" : "Extend / History"}
                            </Typography>
                          )}
                        </Grid>
                      )}
                    </Grid>
                    <Typography className={Styles.headline} mt={1.5}>
                      {selectedData?.title}
                    </Typography>
                    <Typography className={Styles.content} mt={1} mb={2}>
                      {selectedData?.description}
                    </Typography>
                    {/* <Divider sx={{ backgroundColor: "#D5D7E8", opacity: 0.4 }} /> */}
                  </Box>
                </Box>
                <Box
                  sx={{
                    marginBottom: "30px",
                  }}
                >
                  <Accordion
                    elevation={0}
                    disableGutters
                    sx={{
                      backgroundColor: "#F4FAFF",
                      position: "absolute",
                      zIndex: 99,
                      width: "100%",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="subject"
                      sx={{
                        height: 24,
                        minHeight: 24,
                      }}
                    >
                      <Typography className={Styles?.content}>
                        Subject
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails id="subject" sx={{ zIndex: 9999 }}>
                      <Typography className={Styles?.content}>
                        {selectedData?.subject}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Box>
            </Box>
            <Box
              className={Styles.bigContainerBottom}
              sx={{
                paddingTop: "0px",
                height: "57vh",
                overflow: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                msOverflowStyle: "none", // For Internet Explorer
                scrollbarWidth: "none",
              }}
            >
              {openLoader ? (
                <div style={{ textAlign: "center", width: "100%" }}>
                  <ColorRing
                    visible={true}
                    height="60"
                    width="60"
                    ariaLabel="color-ring-loading"
                    wrapperStyle={{}}
                    wrapperClass="color-ring-wrapper"
                    colors={[
                      "#00675D",
                      "#00675D",
                      "#00675D",
                      "#00675D",
                      "#00675D",
                    ]}
                  />
                </div>
              ) : (
                <Box sx={{ width: "100%" }}>
                  {replyMessages?.length > 0 ? (
                    replyMessages?.map((e, i) => {
                      let start = moment(selectedData?.assignedAt);
                      let end = moment(e?.date);
                      if (i == 0) {
                        start = moment(selectedData?.createdAt);
                        end = moment(selectedData?.assignedAt);
                      }
                      const duration = moment.duration(end.diff(start));

                      const hours = Math.floor(duration.asHours());
                      const minutes = duration.minutes();
                      const seconds = duration.seconds();

                      const formatted = `${hours
                        .toString()
                        .padStart(2, "0")}:${minutes
                        .toString()
                        .padStart(2, "0")}:${seconds
                        .toString()
                        .padStart(2, "0")}`;
                      {
                        /* {filteredMessages?.length > 0 ? (
                    filteredMessages.map((e, i) => { */
                      }
                      return (
                        <Box
                          sx={{ display: "flex", justifyContent: "center" }}
                          key={i}
                          ref={endOfMessagesRef}
                        >
                          {e?.isAutoGenerated === true ? (
                            <>
                              <Stack
                                direction={"row"}
                                sx={{
                                  display: "flex !important",
                                  justifyContent: "center !important",
                                  alignItems: "center !important",
                                }}
                              >
                                <Typography
                                  className={Styles.content}
                                  mt={1}
                                  mb={1}
                                  sx={{
                                    display: "flex !important",
                                    justifyContent: "center !important",
                                    alignItems: "center !important",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: e?.message,
                                  }}
                                />
                              </Stack>
                            </>
                          ) : currentUserId === e.userId ? (
                            <>
                              <Box
                                className={Styles.myChatContainer}
                                mt={1}
                                // sx={{
                                //   display: "flex",
                                //   flexDirection: "column",
                                //   width: "100%",
                                // }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 2,
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Box>
                                    <Typography
                                      className={Styles.logo}
                                      sx={{
                                        // backgroundColor: e.message
                                        //   ? "#8A50FC"
                                        //   : "#F54D60",
                                        backgroundColor: "#26a69a",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {e.userId === null ? (
                                        <SupportAgentIcon />
                                      ) : (
                                        <ReplyIcon />
                                      )}
                                    </Typography>
                                  </Box>
                                  <div
                                    className={Styles["mail-action-container"]}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography className={Styles.headline}>
                                        {e?.name === null
                                          ? e.email?.split("@")[0] ||
                                          "Unknown User"
                                          : e?.name === ""
                                            ? e.email?.split("@")[0] ||
                                            "Unknown User"
                                            : e.name || e.email?.split("@")[0]}
                                      </Typography>
                                      <Typography className={Styles.content}>
                                        &nbsp;&nbsp; (
                                        {/* {currentUserId === e.userId
                                          ? selectedData?.assignedToInfo?.email
                                          : currentUserEmail} */}
                                        {e?.email === null
                                          ? "Unknown Mail"
                                          : e.email}
                                        )
                                      </Typography>
                                      <Typography
                                        className={Styles.date}
                                        mt={0.5}
                                      >
                                        &nbsp;&nbsp; {formatted}
                                      </Typography>
                                      &nbsp;&nbsp;&nbsp;&nbsp;
                                      {!e?.isFromStaff&&e?.sendStatus && (
                                        <Typography
                                          sx={{
                                            background: "#94fff5",
                                            borderTopLeftRadius: 10,
                                            borderBottomLeftRadius: 10,
                                            borderTopRightRadius: 10,
                                            borderBottomRightRadius: 10,
                                            color: "#006960",
                                            // minWidth: 40,
                                            paddingLeft: 1,
                                            paddingRight: 1,
                                            height: 15,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 11.5,
                                            border: "1px solid #006960",
                                          }}
                                        >
                                          {e?.sendStatus === "2" &&
                                          !e?.isFromStaff
                                            ? "init"
                                            : e?.sendStatus === "4" &&
                                              !e?.isFromStaff
                                            ? "final"
                                            : e?.sendStatus === "5" &&
                                              !e?.isFromStaff
                                            ? "need-info"
                                            : null}
                                        </Typography>
                                      )}
                                    </Box>
                                    <Typography
                                      className={Styles.date}
                                      mt={0.5}
                                    >
                                      {moment(e?.date).format(
                                        "DD MMM YYYY, hh:mma"
                                      )}{" "}
                                      -{" "}
                                      <span style={{ color: "black" }}>
                                        {selectedData?.ticketId}
                                      </span>
                                    </Typography>
                                    {e.isCloseMessage ? (
                                      <>
                                        <Typography
                                          className={Styles.content}
                                          mb={1}
                                        >
                                          Ticket Close Confirmation Sended
                                        </Typography>
                                      </>
                                    ) : (
                                      <Typography
                                        className={Styles.myChatReplycontent}
                                        mt={1}
                                        mb={1}
                                        dangerouslySetInnerHTML={{
                                          __html: e?.message,
                                        }}
                                      />
                                    )}
                                    {/* {e?.message}
                                    </Typography> */}
                                    {e?.documents?.length > 0 && (
                                      <Stack
                                        className={Styles.headline}
                                        mt={1}
                                        mb={1}
                                        spacing={2}
                                        // direction={"row"}
                                        // sx={{ justifyContent: "space-arround" }}
                                      >
                                        {e?.documents.map((doc, index) =>
                                          doc?.fileUrl ? (
                                            isAudioDocument(doc) ? (
                                              <Stack key={index}>
                                                <audio
                                                  controls
                                                  preload="metadata"
                                                  src={doc.fileUrl}
                                                  style={{ maxWidth: "280px" }}
                                                />
                                              </Stack>
                                            ) : doc.fileUrl.endsWith(".pdf") ||
                                            doc.fileUrl.endsWith(".xlsx") ? (
                                              <Stack key={index}>
                                                <a
                                                  href={doc.fileUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{ width: "20px" }}
                                                >
                                                  <img
                                                    src={
                                                      doc.fileUrl.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? PDFImage
                                                        : XLSXImage
                                                    } // Use the correct image based on the file type
                                                    alt={
                                                      doc.fileUrl.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? "PDF"
                                                        : "XLSX"
                                                    }
                                                    height="30px"
                                                  />
                                                </a>
                                              </Stack>
                                            ) : (
                                              <Stack key={index}>
                                                <a
                                                  href={doc.fileUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    width: "100px",
                                                  }}
                                                >
                                                  <img
                                                    src={doc.fileUrl}
                                                    alt={doc.fileName}
                                                    style={{
                                                      maxWidth: "130px",
                                                      maxHeight: "130px",
                                                      objectFit: "contain",
                                                      display: "block",
                                                    }}
                                                  />
                                                </a>
                                              </Stack>
                                            )
                                          ) : null
                                        )}
                                      </Stack>
                                    )}
                                  </div>
                                </Box>

                                {/* <Divider
                                  sx={{
                                    backgroundColor: "#D5D7E8",
                                    opacity: 0.4,
                                  }}
                                /> */}
                              </Box>
                            </>
                          ) : (
                            <>
                              <Box className={Styles.responseContainer} mt={1}>
                                <Box>
                                  <Typography
                                    className={Styles.logo}
                                    sx={{
                                      backgroundColor: e.replyMessages
                                        ? "#26a69a"
                                        : "#F54D60",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    <SupportAgentIcon />
                                    {/* {e.userId === null ? (
                                    <SupportAgentIcon />
                                  ) : (
                                    <ReplyIcon />
                                  )} */}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    paddingLeft: "18px",
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    position: "relative",
                                  }}
                                >
                                  <div
                                    className={Styles["mail-action-container"]}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Typography className={Styles.headline}>
                                        {/* {e.isReply ? "Helpdesk" : e?.name} */}
                                        {/* {e?.name === null
                                          ? "Unknown User"
                                          : e?.name === ""
                                          ? "Not Available"
                                          : e.name} */}
                                        {e?.name === null
                                          ? e.email?.split("@")[0] ||
                                          "Unknown User"
                                          : e?.name === ""
                                            ? e.email?.split("@")[0] ||
                                            "Unknown User"
                                            : e.name || e.email?.split("@")[0]}
                                      </Typography>
                                      <Typography className={Styles.content}>
                                        {/* &nbsp;&nbsp;({e?.email}) */}
                                        &nbsp;&nbsp;(
                                        {e?.email === null
                                          ? "Unknown Mail"
                                          : e.email}
                                        )
                                      </Typography>
                                      <Typography
                                        className={Styles.date}
                                        mt={0.5}
                                      >
                                        &nbsp;&nbsp; {formatted}
                                      </Typography>
                                      {!e?.isFromStaff && e?.sendStatus && (
                                        <>
                                          &nbsp;&nbsp;&nbsp;
                                          <Typography
                                            sx={{
                                              background: "#94fff5",
                                              borderTopLeftRadius: 10,
                                              borderBottomLeftRadius: 10,
                                              borderTopRightRadius: 10,
                                              borderBottomRightRadius: 10,
                                              color: "#006960",
                                              // minWidth: 40,
                                              paddingLeft: 1,
                                              paddingRight: 1,
                                              height: 15,
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              fontSize: 11.5,
                                              border: "1px solid #006960",
                                            }}
                                          >
                                            {e?.sendStatus === "2" &&
                                            !e?.isFromStaff
                                              ? "init"
                                              : e?.sendStatus === "4" &&
                                                !e?.isFromStaff
                                              ? "final"
                                              : e?.sendStatus === "5" &&
                                                !e?.isFromStaff
                                              ? "need-info"
                                              : null}
                                          </Typography>
                                        </>
                                      )}
                                    </Box>
                                    <Typography
                                      className={Styles.date}
                                      mt={0.5}
                                    >
                                      {moment(e?.date).format(
                                        "DD MMM YYYY, hh:mma"
                                      )}{" "}
                                      -{" "}
                                      <span style={{ color: "black" }}>
                                        {selectedData?.ticketId}
                                      </span>
                                    </Typography>

                                    {/* <Typography
                                    className={Styles.headline}
                                    mt={1}
                                    mb={1}
                                  >
                                    {e?.message}
                                  </Typography> */}
                                    {e.isCloseMessage ? (
                                      <>
                                        <Typography className={Styles.content}>
                                          Please confirm if you want to close
                                          the ticket.
                                        </Typography>
                                        <Stack
                                          direction={"row"}
                                          spacing={2}
                                          m={1}
                                        >
                                          <Button
                                            type="button"
                                            // onClick={() =>
                                            //   handleButtonClick(
                                            //     "yes",
                                            //     selectedData?.ticketId
                                            //   )
                                            // }
                                            onClick={() => updateTicketStatus()}
                                            sx={{
                                              backgroundColor: "#00675d",
                                              fontWeight: "600",
                                              fontSize: "10px",
                                              color: "#ffffff",
                                              height: "20px",
                                              width: "10px",
                                              textTransform: "capitalize",
                                              // padding: "4px 10px",
                                            }}
                                          >
                                            Yes
                                          </Button>
                                          <Button
                                            type="button"
                                            onClick={() =>
                                              handleButtonClick(
                                                "no",
                                                selectedData?.ticketId
                                              )
                                            }
                                            sx={{
                                              backgroundColor: "#cc0000",
                                              fontWeight: "600",
                                              fontSize: "10px",
                                              color: "#ffffff",
                                              height: "20px",
                                              width: "10px",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            No
                                          </Button>
                                        </Stack>
                                      </>
                                    ) : (
                                      <Typography
                                        className={`${
                                          Styles.chatReplycontent
                                        } ${
                                          [
                                            "Initial",
                                            "Follow up",
                                            "Final",
                                          ].includes(e?.message?.trim())
                                            ? Styles.SendStatus
                                            : ""
                                        }`}
                                        mt={1}
                                        mb={1}
                                        dangerouslySetInnerHTML={{
                                          __html: e?.message,
                                        }}
                                      />
                                    )}

                                    {e?.documents?.length > 0 && (
                                      <Stack
                                        className={Styles.headline}
                                        mt={1}
                                        mb={1}
                                        spacing={2}
                                        // direction={"row"}
                                        // sx={{ justifyContent: "space-arround" }}
                                      >
                                        {e?.documents.map((doc, index) =>
                                          doc?.fileUrl ? (
                                            isAudioDocument(doc) ? (
                                              <Stack key={index}>
                                                <audio
                                                  controls
                                                  preload="metadata"
                                                  src={doc.fileUrl}
                                                  style={{ maxWidth: "280px" }}
                                                />
                                              </Stack>
                                            ) : doc.fileUrl.endsWith(".pdf") ||
                                            doc.fileUrl.endsWith(".xlsx") ? (
                                              <Stack key={index}>
                                                <a
                                                  href={doc.fileUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{ width: "50px" }}
                                                >
                                                  <img
                                                    src={
                                                      doc.fileUrl.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? PDFImage
                                                        : XLSXImage
                                                    } // Use the correct image based on the file type
                                                    alt={
                                                      doc.fileUrl.endsWith(
                                                        ".pdf"
                                                      )
                                                        ? "PDF"
                                                        : "XLSX"
                                                    }
                                                    height="70px"
                                                  />
                                                </a>
                                              </Stack>
                                            ) : (
                                              <Stack key={index}>
                                                <a
                                                  href={doc.fileUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    width: "100px",
                                                  }}
                                                >
                                                  <img
                                                    src={doc.fileUrl}
                                                    alt={doc.fileName}
                                                    style={{
                                                      maxWidth: "130px",
                                                      maxHeight: "130px",
                                                      objectFit: "contain",
                                                      display: "block",
                                                    }}
                                                  />
                                                </a>
                                              </Stack>
                                            )
                                          ) : null
                                        )}
                                      </Stack>
                                    )}

                                    {/* <div className={Styles["child-action"]}>
                              <ModeIcon
                                sx={{
                                  display: viewConfig.isEdit
                                    ? "block"
                                    : "none",
                                }}
                                onClick={() => {
                                  setOpenDrawer(true);
                                  setSelectedMessage(e);
                                }}
                              />
                              <DeleteIcon
                                sx={{
                                  display: viewConfig.isDelete
                                    ? "block"
                                    : "none",
                                }}
                                onClick={() => {
                                  setSelectedId(e._id);
                                  setOpendialogBox(true);
                                }}
                              />
                            </div> */}
                                  </div>

                                  {/* <Divider
                                    sx={{
                                      backgroundColor: "#D5D7E8",
                                      opacity: 0.4,
                                    }}
                                  /> */}
                                </Box>
                              </Box>
                            </>
                          )}
                        </Box>
                      );
                    })
                  ) : (
                    <div>No replies available</div>
                  )}
                </Box>
              )}
            </Box>
            {(status === "Open" || selectedData.ticketStatus === "0") && (
              <Box className={Styles.replyMsgContainer}>
                <Button
                  endIcon={<ReplyRoundedIcon />}
                  className={Styles.replyMsgButton}
                  onClick={() => setOpenMailBox(!openMailBox)}
                >
                  Compose
                </Button>
              </Box>
            )}
          </Box>
          {openMailBox && (
            <Box className={Styles.richTextEditor} sx={{ background: "white" }}>
              <Box className={Styles.richTextEditorContentBox}>
                <Box sx={{ padding: "14px" }}>
                  {/* <Grid container sx={{ pb: "4px" }}>
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          padding: "4px 0",
                        }}
                      >
                        <Typography className={Styles.toValue}>
                          Subject : &nbsp;&nbsp;
                        </Typography>
                        <Typography className={Styles.toTitle}>
                          {selectedData.ticketId}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <CloseIcon
                        sx={{ color: "red", cursor: "pointer" }}
                        onClick={() => {
                          setOpenMailBox(false);
                          setDocuments(null);
                          setFileName("");
                        }}
                      />
                    </Grid>
                  </Grid> */}
                  {/* <Divider sx={{ backgroundColor: "#D5D7E8", opacity: 0.6 }} /> */}
                  <Box>
                    <textarea
                      placeholder="Message..."
                      onChange={(e) =>
                        // setMailValues({ ...mailValues, body: e.target.value })
                        setMailValues({ body: e.target.value })
                      }
                      style={{ height: "100%" }}
                    ></textarea>
                  </Box>
                </Box>
                <Stack direction={"row"} spacing={2} alignItems="center">
                  {fileName && (
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#333",
                        fontWeight: 600,
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      Selected file:
                      <span
                        style={{
                          color: "#757575",
                          fontWeight: 400,
                          fontStyle: "italic",
                          paddingLeft: "10px",
                        }}
                      >
                        {fileName}
                      </span>
                    </Typography>
                  )}
                </Stack>
                <Box className={Styles.sendButtonContiner}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1.5}
                    sx={{ paddingLeft: "20px" }}
                  >
                    <>
                      <Tooltip title="Upload File">
                        <AttachFileIcon
                          onClick={handleIconClick}
                          sx={{
                            transform: "rotate(90deg)",
                            // color: "red",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                        multiple
                      />
                    </>
                    <VoiceRecorder
                      voice={voiceNote}
                      onChange={setVoiceNote}
                      disabled={sendOpenLoader}
                      onError={(msg) =>
                        dispatch(showToast({ message: msg, type: "error" }))
                      }
                    />
                  </Stack>
                  <Stack direction={"row"} spacing={2}>
                    <Button
                      // onClick={sendCloseMailFunction}
                      onClick={updateTicketStatus}
                      className={Styles.sendButton}
                      style={{ display: "none" }}
                      endIcon={
                        sendCloseLoader ? (
                          <CircularProgress
                            sx={{ color: "white" }}
                            thickness={6}
                            size={10}
                          />
                        ) : (
                          <SendIcon sx={{ height: "12px", width: "12px" }} />
                        )
                      }
                    >
                      Close Message
                    </Button>
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                      className={Styles.cancelButton}
                    >
                      <Typography
                        sx={{ fontSize: "14px" }}
                        onClick={() => {
                          setOpenMailBox(false);
                          setDocuments(null);
                          setFileName("");
                          clearVoiceNote();
                        }}
                      >
                        Cancel
                      </Typography>
                    </Grid>
                    {/* <Button
                      onClick={sendMailFunction}
                      className={Styles.sendButton}
                      endIcon={
                        sendOpenLoader ? (
                          <CircularProgress
                            sx={{ color: "white" }}
                            thickness={6}
                            size={10}
                          />
                        ) : (
                          <SendIcon sx={{ height: "12px", width: "12px" }} />
                        )
                      }
                    >
                      Send
                    </Button> */}
                    <Button
                      onClick={handleSendClick}
                      className={Styles.sendButton}
                      endIcon={
                        sendOpenLoader ? (
                          <CircularProgress
                            sx={{ color: "white" }}
                            thickness={6}
                            size={10}
                          />
                        ) : (
                          <SendIcon sx={{ height: "12px", width: "12px" }} />
                        )
                      }
                      disabled={sendOpenLoader}
                    >
                      Send
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          boxShadow: "none",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          padding: 0,
                        },
                      }}
                      MenuListProps={{
                        disablePadding: true,
                        autoFocusItem: false,
                      }}
                    >
                      {filteredSendOptions.map((option, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handleOptionClick(option.value)}
                          sx={{
                            borderTop: index !== 0 ? "1px solid #eee" : "none",
                            display: "flex",
                            alignItems: "center",
                            "&:focus": {
                              backgroundColor: "transparent",
                            },
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Menu>
                  </Stack>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      ) : (
        <Box className={Styles.EmptyImageContainer}>
          <Typography className={Styles.selectHeading}>
            Select an item to read
          </Typography>
          <img src={EmptyDataImage} alt="empty" />
          <Typography className={Styles.nothingTitle}>
            Nothing is selected
          </Typography>
        </Box>
      )}
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        <div className="addRenderingContainer">
          <Box className="addContainerHeader">
            <Typography>Edit Message</Typography>
            <CloseIcon
              onClick={() => setOpenDrawer(false)}
              sx={{ cursor: "pointer" }}
            />
          </Box>
          <Formik
            initialValues={{
              body: selectedMessage?.body || "",
              isReply: selectedMessage?.isReply,
              date: selectedMessage?.date || null,
            }}
            enableReinitialize
            onSubmit={(values) => handleEditMessage(values)}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Box className="addContainerCenter" mb={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <Typography className="inputLabel">
                        Message Type
                      </Typography>
                      <FormControl>
                        <RadioGroup
                          row
                          sx={{
                            display: "flex",
                            gap: "30px",
                            alignItems: "center",
                          }}
                        >
                          <FormControlLabel
                            value={false}
                            label="Incomming"
                            control={
                              <Radio
                                size="small"
                                checked={values.isReply ? false : true}
                                onChange={(e) =>
                                  setFieldValue(
                                    "isReply",
                                    JSON.parse(e.target.value)
                                  )
                                }
                              />
                            }
                          />
                          <FormControlLabel
                            value={true}
                            label="Outgoing"
                            control={
                              <Radio
                                size="small"
                                checked={values.isReply ? true : false}
                                onChange={(e) =>
                                  setFieldValue(
                                    "isReply",
                                    JSON.parse(e.target.value)
                                  )
                                }
                              />
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Typography className="inputLabel">
                        {values.isReply
                          ? "Outgoing Date & Time"
                          : "Incomming Date & Time"}
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DateTimePicker
                            onChange={(e) => setFieldValue("date", e.$d)}
                            renderInput={(params) => <TextField {...params} />}
                            format="DD/MM/YYYY  -  HH:mm"
                            className="datePicker w-100"
                            value={values.date ? dayjs(values.date) : null}
                            // disabled={definedRole === Roles[1] ? true : false}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Typography className="inputLabel">Body</Typography>
                      <Field
                        name="body"
                        className="InputField w-100"
                        placeholder="Enter Body"
                        as="textarea"
                        style={{ height: "100px" }}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Grid className="addboxFooter">
                  <Button
                    className="cancelButton"
                    onClick={() => setOpenDrawer(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="saveButton"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        </div>
      </Dialog>
      {/* <ConfirmBox
        open={openDialogBox}
        title="Delete"
        content="Are you sure want to Delete this record ?"
        confirmButton="Delete"
        setOpenConfirmBox={setOpendialogBox}
        confirmFunction={DeleteFunction}
      /> */}
      <ConfirmBox
        open={openSupportConfirmBox}
        title="Support Ticket"
        content={`Are you sure you want to ${
          pendingValue ? "enable" : "disable"
        } support ticket?`}
        confirmButton="Confirm"
        setOpenConfirmBox={setOpenSupportConfirmBox}
        Function={handleSupportTicket}
      />
    </div>
  );
};

export default ContentFeedback;
